(function ($, Drupal) {
  Drupal.behaviors.productList = {
    attach: function (context, settings) {
      var sortBySelect = context.querySelector("select[name='sort_bef_combine']");
      if (sortBySelect) {
        $('select[name="sort_bef_combine"]').on('change', promocionSort);
        window.onload = function() {
          if ($('select[name="sort_bef_combine"]').val() == "promocion_DESC") {
            context.querySelector("input[name='promocion']").value = 1;
            var btnSearch = context.querySelector('.form-submit');
            btnSearch.click();
            return;
          } else {
            context.querySelector("input[name='promocion']").value = "All";
          }
        }
      }

      var promoSort = context.querySelector('#edit-promocion--2--wrapper');
      if (promoSort) {
        promoSort.style.display = 'none';
      }

      function promocionSort(e) {
        if (this.value == "promocion_DESC") {
          context.querySelector("input[name='promocion']").value = 1;
        } else {
          context.querySelector("input[name='promocion']").value = "All";
        }

        var btnSearch = context.querySelector('.form-submit');
        btnSearch.click();
      }

      // var promoSortHome = context.querySelector('#edit-promocion--wrapper');
      // if (promoSortHome) {
      //   promoSortHome.style.display = 'none';
      // }
    }
  };
})(jQuery, Drupal);
  